import { defaultLogger } from './functions';
import { LoggerArgs, LoggerBaseType, LoggerOptions } from './types';

export class Logger {
	#debug: Array<LoggerBaseType>;
	#info: Array<LoggerBaseType>;
	#warn: Array<LoggerBaseType>;
	#error: Array<LoggerBaseType>;

	constructor (options: Partial<LoggerOptions> | null) {
		const loggers = options?.loggers ?? null;

		this.#debug = [];
		this.#info = [];
		this.#warn = [];
		this.#error = [];

		if (loggers === null) {
			const logger = defaultLogger();
			this.#debug.push(logger.debug);
			this.#info.push(logger.info);
			this.#warn.push(logger.warn);
			this.#error.push(logger.error);
		} else {
			loggers.forEach((l) => {
				if (l.debug) this.#debug.push(l.debug);
				if (l.info) this.#info.push(l.info);
				if (l.warn) this.#warn.push(l.warn);
				if (l.error) this.#error.push(l.error);
			});
		}
	}

	public debug (message: string, ...args: LoggerArgs): void { this.#debug.forEach((d) => { d(message, args); }); }
	public info (...args: LoggerArgs): void { this.#info.forEach((d) => { d(args); }); }
	public warn (...args: LoggerArgs): void { this.#warn.forEach((d) => { d(args); }); }
	public error (...args: LoggerArgs): void { this.#error.forEach((d) => { d(args); }); }
}
